import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { createReferral } from "@requests/referralConversions"

const REFERRAL_TOKEN_KEY = "referral_token"

function getOrCreateReferralToken(): string {
  let token = localStorage.getItem(REFERRAL_TOKEN_KEY)
  if (!token) {
    token = crypto.randomUUID()
    localStorage.setItem(REFERRAL_TOKEN_KEY, token)
  }
  return token
}

// Captures a referral when arriving via a tracked link (?utm_source=...).
// Pass postId for a post-scoped share (e.g. PostScreen); omit it for a
// general share of the app itself (e.g. the homepage).
export function useReferralCapture(postId?: string): void {
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const source = params.get("utm_source")
    if (!source) return

    const anonymousToken = getOrCreateReferralToken()
    createReferral({
      post_id:          postId,
      source,
      section:          params.get("utm_term"),
      campaign:         params.get("utm_campaign"),
      referrer_user_id: params.get("ref"),
      anonymous_token:  anonymousToken,
    }).catch(() => {})
    // Re-fires on postId change (post-to-post nav) or pathname change (e.g.
    // band-to-band nav, where postId is never set) - never on search alone,
    // so this only runs once per real landing, not on every filter/sort tweak.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId, location.pathname])
}
